import React from 'react';
import ProjectPage from '../../components/projects/ProjectPage';
import gardenData from '../../data/projects/garden.js';

function Garden() {
  return <ProjectPage projectData={gardenData} />;
}

export default Garden;
